import { render } from "./DetailsSkeleton.vue?vue&type=template&id=1eeec001"
import script from "./DetailsSkeleton.vue?vue&type=script&lang=js"
export * from "./DetailsSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__